<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <danger-class-create-or-update v-model="dangerClass" :errors="errors"></danger-class-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="danger-class"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ShipableProductApi from '@/api/shipable-product'
import DangerClassCreateOrUpdate from './components/DangerClassCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        DangerClassCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            dangerClass:{
                Id:0,
                Name:null
            },
            fields:[
                { name:"Tehlike Sınıfı",key:"Name", thClass:"w-100",sortable:true,},
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.dangerClass.Id = 0
            this.dangerClass.Name = null
           
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.dangerClass.Id = item.Id
            this.dangerClass.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            ShipableProductApi.DangerClass.CreateOrUpdate(this.editing,this.dangerClass)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return ShipableProductApi.DangerClass.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} tehlike sınıfı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    ShipableProductApi.DangerClass.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>